var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstrellaNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30.4 28.9",
    style: {
      enableBackground: "new 0 0 30.4 28.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF0072;}\n\t.st1{fill:#F1F1EF;}\n\t.st2{font-family:'Arial-BoldMT';}\n\t.st3{font-size:5.12px;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "15.2,3.7 19.9,0 21.5,5.8 27.5,5.5 25.4,11.1 30.4,14.5 25.4,17.8 27.5,23.4 21.5,23.1 19.9,28.9  15.2,25.2 10.5,28.9 8.9,23.1 2.9,23.4 5,17.8 0,14.5 5,11.1 2.9,5.5 8.9,5.8 10.5,0  "
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 7.3664 15.6828)",
    className: "st1 st2 st3"
  }, "Nuevo"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstrellaNew);
export default __webpack_public_path__ + "static/media/estrella_new.869648e3e9bead630a39b2ef5586c9c9.svg";
export { ForwardRef as ReactComponent };